(function () {
    var directivesModule = angular.module('customeDirectivesModule');
    directivesModule.directive('autoResize', autoResize);

    autoResize.$inject = ['$timeout'];
    function autoResize($timeout) {
        var directive = {
            restrict: 'A',
            link: function autoResizeLink(scope, element, attributes, controller) {
                element.css({ 'height': '100px', 'overflow-y': 'auto' });
                element.on('focus', function () {
                    extendHeight();
                });
                element.on('input', function () {
                    extendHeight();
                });

                scope.$watch(attributes.ngModel, function (newVal) {
                    if (!newVal) {
                        element.css({ 'height': '100px'});
                    }
                });

                function extendHeight() {
                    var height = element[0].scrollHeight;
                    height = (!height || height <= 100) ? 100 : height + 2;
                    element.css('height', height + 'px');
                }
            }
        };
        return directive;
    };
})();